import React, {useContext} from "react";
import PropTypes from 'prop-types';
import makeStyles from "@material-ui/core/styles/makeStyles";
import DefaultType from "../../../Utils/Form/FormDynamic/Fields/DefaultType/DefaultType";
import TextType from "../../../Utils/Form/FormDynamic/Fields/TextType";
import MenuDesignerContext from "../../../ContextComponents/MenuDesignerContext";
import TypeEntity from "../../../Utils/Form/FormDynamic/Fields/EntityExternal/Entity";
import IconSelectType from "../../../Utils/Form/FormDynamic/Fields/IconSelectType/IconSelectType";
import {Typography} from "@material-ui/core";

const useStyles = makeStyles(() => ({
    container: {
        padding: 10
    }
}));

const GeneralInformation = () => {
    const {onChangeValues, values} = useContext(MenuDesignerContext);
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div>
                <DefaultType
                    fieldStyles={{width: '350px'}}
                    labelStyles={{width: '100px'}}
                    field={{
                        path: 'id',
                        label: "ID",
                        autofocus: true
                    }}
                    setValue={onChangeValues}
                    values={values}
                />
                <DefaultType
                    fieldStyles={{width: '350px'}}
                    labelStyles={{width: '100px'}}
                    field={{
                        path: 'name',
                        label: "Name"
                    }}
                    setValue={onChangeValues}
                    values={values}
                />
                <TextType
                    fieldStyles={{width: '350px'}}
                    labelStyles={{width: '100px'}}
                    field={{
                        path: 'description',
                        label: "Description"
                    }}
                    setValue={onChangeValues}
                    values={values}
                />
                <TypeEntity
                    values={values}
                    field={{
                        type: 'entityExternal',
                        path: 'application',
                        label: "Application",
                        entity: "application",
                        isArray: true
                    }}
                    setValue={onChangeValues}
                    fieldStyles={{width: '350px'}}
                    labelStyles={{width: '100px'}}
                />
            </div>

            <div style={{marginTop: 35}}>
                <Typography variant="body2" component="div">Multi Role Settings</Typography>
                {/*<Divider style={{margin: "10px 0"}}/>*/}
                <div style={{padding: 10}}>
                    <DefaultType
                        fieldStyles={{width: '350px'}}
                        labelStyles={{width: '100px'}}
                        field={{
                            path: 'multiRoleSettings.label',
                            label: "Label"
                        }}
                        setValue={onChangeValues}
                        values={values}
                    />
                    <IconSelectType
                        values={values}
                        field={{
                            path: 'multiRoleSettings',
                            label: "Icon",
                        }}
                        setValue={onChangeValues}
                        fieldStyles={{width: '350px'}}
                        labelStyles={{width: '100px'}}
                    />
                </div>
            </div>
        </div>
    )
};

export default GeneralInformation

GeneralInformation.propTypes = {
    values: PropTypes.object,
    setValue: PropTypes.func
};
